import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { RenderHTML } from "@app/utils/htmlUtils"
import localStore from "@app/utils/localStore"
import { Modal, useModal } from "@tecreation/funnel-components"
import "./styles.css"
export default function NotificationInfoModal({ desktopTitle, mobileTitle, mobileContent, desktopContent, disableClose, overlayId }) {
	const modal = useModal()
	const {
		data: { buttonClose },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<Modal ariaLabelledBy="notification-modal-title" ariaDescribedBy="notification-modal-subtitle">
			{!disableClose && <Modal.Closer ariaLabel={buttonClose} />}
			<Modal.Header>
				<h2 className="info__desktop h-without-default-style" id="notification-modal-title">
					<RenderHTML html={desktopTitle} />
				</h2>
				<h2 className="info__mobile h-without-default-style">
					<RenderHTML html={mobileTitle} />
				</h2>
			</Modal.Header>
			<Modal.Body>
				<div className="info__desktop" id="notification-modal-subtitle">
					<RenderHTML html={desktopContent} />
				</div>
				<div className="info__mobile">
					<RenderHTML html={mobileContent} />
				</div>
			</Modal.Body>

			{!disableClose && (
				<Modal.Footer className="flex flex-center">
					<Button
						style="primary"
						onClick={() => {
							const usedModalIds = JSON.parse(localStore.getItem("usedModalIds") || "[]")
							usedModalIds.push(overlayId)
							localStore.setItem("usedModalIds", JSON.stringify(usedModalIds))
							modal.hideModal()
						}}
					>
						{buttonClose}
					</Button>
				</Modal.Footer>
			)}
		</Modal>
	)
}
